export default "__VITE_ASSET__235982b0__"